import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Collapsible } from '../../abstracts/collapsible.abstract';

@Component({
    selector: 'app-collapsible-container',
    templateUrl: './collapsible-container.component.html',
    styleUrls: ['./collapsible-container.component.scss'],
})
export class CollapsibleContainerComponent extends Collapsible implements OnInit {
    @Input() public id: string;
    @Input() public title: string;
    @Input() public icon: string;
    @Input() public maxSelection = 0;
    @Input() public currentSelected = 0;

    constructor(private deviceDetector: DeviceDetectorService, private store: Store) {
        super();
    }

    public ngOnInit(): void {
        if (
            (window.innerWidth <= 768 || this.deviceDetector.isMobile()) &&
            ![
                'personalData',
                'generalData',
                'adminData',
                'mealFees',
                'homeworkPrice',
                'nurserySchedules',
                'dashboardEtatCompte',
                'dashboardDebitCredit',
                'dashboardAttestations',
            ].includes(this.id)
        ) {
            this.toggleCollapsed();
        }
    }
}
